<div class="container_dati_generali" >
  <div class="row"> 
      <div class="col-sm-12">
  
        <p>Dati non presenti, aggiornare dati</p>
  
      </div>
  </div>
</div>